import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CargoTable from '../components/CargoTable';
import { Container, Form, Button, Card } from 'react-bootstrap';
import AlertOverlay from "../../../components/Alert";
import { postCargo } from '../../../services/cargoService';
import { getListaCargoDocumentType } from '../../../services/cargoDocumentTypeService';
import { getUiInterface, getPageName } from '../../../locales/translationUtils';

interface Document {
  id: number;
  key: string;
}
const StepTwoView: React.FC = () => {
  const location = useLocation();
  const formData = location.state?.formData || {};
  const [cargoDocumentTypeList, setCargoDocumentTypeList] = useState<
    Document[]
  >([]);
  const [invoice, setInvoice] = useState('');
  const [document, setDocument] = useState('');
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isLoading, setIsLoading] = useState(false);
     const [alert, setAlert] = useState<{
          message: string;
          variant: "success" | "danger" | "warning" | "info";
      } | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getListaCargoDocumentType();
        setCargoDocumentTypeList(response.values || []);
      } catch (error) {
        console.error('Erro ao buscar documentos:', error);
      }
    };

    fetchData();
  }, []);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (
      !invoice.trim() ||
      !document ||
      selectedFiles.length === 0
    ) {
      setAlert({ message: getUiInterface("fieldRequired"), variant: "danger" });
      return;
    }
  
    setIsLoading(true);
    try {
      const payload = new FormData();
  
      Object.entries(formData).forEach(([key, value]) => {
        if (
          key !== 'Dimensions' &&
          key !== 'Weight' &&
          value !== null &&
          value !== undefined
        ) {
          payload.append(key, String(value));
        }
      });
      
      if (formData.Weight !== null && formData.Weight !== undefined) {
        const weightNormalized = normalizeDecimalForApi(formData.Weight);
        payload.append('Weight', weightNormalized);
        payload.append('WeightRaw', String(formData.Weight));
      }
      
      if (formData.Dimensions && Array.isArray(formData.Dimensions)) {
        formData.Dimensions.forEach((dimension: any, i: any) => {
          payload.append(
            `Dimensions[${i}].Quantity`,
            String(dimension.Quantity)
          );
    
          payload.append(
            `Dimensions[${i}].Length`,
            normalizeDecimalForApi(dimension.Length)
          );
          payload.append(
            `Dimensions[${i}].Width`,
            normalizeDecimalForApi(dimension.Width)
          );
          payload.append(
            `Dimensions[${i}].Height`,
            normalizeDecimalForApi(dimension.High)
          );
        });
      }
  
      payload.append('Invoice', invoice);
      payload.append('DocumentTypeId', document);
  
      // Content deve ser enviado como coleção
      selectedFiles.forEach((file, index) => {
        payload.append('Content', file);
      });
      
      // Debug: Log FormData contents
      console.log('=== FormData Contents ===');
      payload.forEach((value, key) => {
        console.log(key, value);
      });
      console.log('========================');
  
      const responseStatus = await postCargo(payload);
  
      if (responseStatus === 201 || responseStatus === 200) {
        setAlert({ message: getUiInterface("registrationCompleted"), variant: "success" });
        setTimeout(() => {
          navigate('/cargo-info');
        }, 1500);
      }
    } catch (error: any) {
      setIsLoading(false);
      console.error('Erro ao enviar os dados:', error);
      
      // Tentar extrair mensagem específica do backend
      let errorMessage = getUiInterface("genericError");
      
      if (error?.response?.data?.errors) {
        const errors = error.response.data.errors;
        const errorMessages = Object.keys(errors).map(key => 
          `${key}: ${errors[key].join(', ')}`
        );
        errorMessage = errorMessages.join('\n');
      } else if (error?.response?.data?.messages?.[0]) {
        errorMessage = error.response.data.messages[0];
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      
      setAlert({ message: errorMessage, variant: "danger" });
    }
  };
  
  function normalizeDecimalForApi(value: number | string) {
    const raw = typeof value === "number" ? value.toString() : String(value);
    let s = raw.trim();
    if (!s) return s;

    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');

    if (lastComma !== -1 && lastDot !== -1) {
      if (lastComma > lastDot) {
        s = s.replace(/\./g, '');
        s = s.replace(/,/g, '.');
      } else {
        s = s.replace(/,/g, '');
      }
    } else if (lastComma !== -1) {
      s = s.replace(/,/g, '.');
    }

    return s;
  }
  
  const handleDocChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDocument(e.target.value);
  };

  const handleInvoiceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInvoice(e.target.value);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
      setSelectedFiles((prev) => [...prev, ...newFiles]);
      // Reset input para permitir selecionar os mesmos arquivos novamente se necessário
      e.target.value = '';
    }
  };

  const handleRemoveFile = (fileName: string) => {
    setSelectedFiles((prev) => prev.filter((file) => file.name !== fileName));
  };

const handleReturnPage = () => {
  navigate('/cargo-info/create', { state: { formData } });
};

  const rows = [{ invoice: invoice, document: document, id: 1 }];

  const columns = [
    { field: 'invoice', headerName: 'Invoice', width: 150 },
    { field: 'document', headerName: 'Document', width: 150 },
  ];

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center vh-100"
      style={{ backgroundColor: '#f5f5f5' }}
    >
        {alert && (
                <AlertOverlay
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert(null)}
                />
            )}
      <Card
        style={{
          width: '50%',
          padding: '20px',
          backgroundColor: 'rgba(255, 255, 255, 0.34)',
          borderRadius: '10px',
        }}
      >
        <Card
          style={{
            width: '100%',
            padding: '20px',
            backgroundColor: 'rgba(151, 146, 146, 0.29)',
            borderRadius: '10px',
          }}
        >
          <h2>{getPageName('invoiceList')}</h2>

          <Form>
            <Form.Group controlId="invoiceInput" className="mb-3">
              <Form.Label>Invoice</Form.Label>
              <Form.Control type="text" onChange={handleInvoiceChange} />
            </Form.Group>

            <Form.Group controlId="docSelect" className="mb-3">
              <Form.Label>Doc</Form.Label>
              <Form.Select value={document} onChange={handleDocChange}>
                <option value="">{getUiInterface('selectAnDoc')}</option>
                {cargoDocumentTypeList?.map((document) => (
                  <option key={document.id} value={document.id}>
                    {document.key}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="fileUpload" className="mb-3">
              <Form.Label>Upload Doc</Form.Label>
              <Form.Control type="file" multiple onChange={handleFileChange} />
              {selectedFiles.length > 0 && (
                <div className="mt-2">
                  <p className="text-muted">Selected files:</p>
                  <ul className="list-unstyled">
                    {selectedFiles.map((file, index) => (
                      <li key={index} className="d-flex align-items-center gap-2 mb-1">
                        <span>{file.name}</span>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemoveFile(file.name)}
                        >
                          X
                        </Button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Form.Group>
          </Form>
        </Card>
        <Card
          style={{
            width: '100%',
            height: '10%',
            backgroundColor: 'rgba(255, 255, 255, 0.34)',
          }}
        >
          <CargoTable
            rows={rows ?? []}
            columns={columns}
            width="100%"
            height={150}
          />
        </Card>
        <div className="d-flex justify-content-end gap-3 mt-3">
          <Button variant="danger" className="w-20" onClick={handleReturnPage} disabled={isLoading}>
            {getUiInterface('return')}
          </Button>
          <Button variant="primary" className="w-20" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {getUiInterface('loading')}
              </>
            ) : (
              getUiInterface('register')
            )}
          </Button>
        </div>
      </Card>
    </Container>
  );
};

export default StepTwoView;
